import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecordSurveySeenMutationVariables = Types.Exact<{
  input: Types.RecordSurveySeenInput;
}>;


export type RecordSurveySeenMutation = { __typename?: 'Mutation', recordSurveySeen?: { __typename?: 'RecordSurveySeenPayload', surveyId: string } | null };


export const RecordSurveySeenDocument = gql`
    mutation RecordSurveySeen($input: RecordSurveySeenInput!) {
  recordSurveySeen(input: $input) {
    surveyId
  }
}
    `;
export type RecordSurveySeenMutationFn = Apollo.MutationFunction<RecordSurveySeenMutation, RecordSurveySeenMutationVariables>;

/**
 * __useRecordSurveySeenMutation__
 *
 * To run a mutation, you first call `useRecordSurveySeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSurveySeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSurveySeenMutation, { data, loading, error }] = useRecordSurveySeenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordSurveySeenMutation(baseOptions?: Apollo.MutationHookOptions<RecordSurveySeenMutation, RecordSurveySeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordSurveySeenMutation, RecordSurveySeenMutationVariables>(RecordSurveySeenDocument, options);
      }
export type RecordSurveySeenMutationHookResult = ReturnType<typeof useRecordSurveySeenMutation>;
export type RecordSurveySeenMutationResult = Apollo.MutationResult<RecordSurveySeenMutation>;
export type RecordSurveySeenMutationOptions = Apollo.BaseMutationOptions<RecordSurveySeenMutation, RecordSurveySeenMutationVariables>;